import React, { useContext, useCallback } from 'react';
import { FaxProvider } from '@mummssoftware/common-ui';
import { GlobalContext, SET_FAX_LIST } from '@mummssoftware/global-context';
import { getSiteFaxList } from '@mummssoftware/utils/pimReader';
import { isAgencyEnabled, getUserName } from '@mummssoftware/utils/utils';
import { Context } from '../../context';

type DashboardFaxProviderProps = {
  children: React.ReactNode;
};

export const DashboardFaxProvider = ({
  children,
}: DashboardFaxProviderProps) => {
  const { siteFaxList, dispatch } = useContext(GlobalContext);
  const { keycloak, agency, currentUser } = useContext(Context);

  const fetchFaxList = useCallback(async () => {
    if (!agency || !keycloak) return;
    const response = await getSiteFaxList(agency, keycloak);
    if (!(response instanceof Response)) {
      dispatch({
        type: SET_FAX_LIST,
        payload: response,
      });
    }
  }, [agency, keycloak, dispatch]);

  const isFaxEnabled = !!isAgencyEnabled(window.env.faxAgency, currentUser);
  const getSenderName = useCallback(() => getUserName(currentUser), [
    currentUser,
  ]);

  const config = {
    siteFaxList,
    fetchFaxList,
    isFaxEnabled,
    getSenderName,
  };

  return <FaxProvider config={config}>{children}</FaxProvider>;
};
